import { useGlobals } from 'hooks/useGlobals';
import { useMemo } from 'react';
import type { SanityProduct } from 'types/cms/SanityProduct';

interface Options {
  required?: boolean;
}

export function useSanityProduct(
  slug: string,
  options: { required: true },
): SanityProduct;
export function useSanityProduct(
  slug?: string,
  options?: Options,
): SanityProduct | null;

export function useSanityProduct(
  slug?: string,
  options: Options = {},
): SanityProduct | null {
  const { data: globals } = useGlobals();
  const { required = false } = options;

  const product = useMemo(() => {
    if (!slug) return null;
    const sanityProduct = globals?.products.find((p) => p.slug === slug);

    if (!sanityProduct) {
      if (required) {
        throw new Error(
          `[useSanityProduct] Required product with slug "${slug}" not found, globals: ${typeof globals}`,
        );
      }
      return null;
    }
    return sanityProduct;
  }, [slug, globals, required]);

  return product;
}
